/* eslint-disable @typescript-eslint/no-require-imports */
import { CardTypeEnum } from '@varo/graphql-schema-types';
import React from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleSheet,
  View,
} from 'react-native';
import AmplitudeMask from 'shared/components/AmplitudeMask/AmplitudeMask';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

export interface CardFrontProps {
  cardType: CardTypeEnum;
  firstNameText: string;
  lastNameText: string;
}

export const CardFront = (props: CardFrontProps) => {
  return (
    <ImageBackground
      source={
        props.cardType === CardTypeEnum.DebitCard
          ? (require('assets/images/vxl/component/digitalCard/debit-card-front.png') as ImageSourcePropType)
          : (require('assets/images/vxl/component/digitalCard/believe-card-front.png') as ImageSourcePropType)
      }
      style={styles.frontImageContainer}
      accessible
      accessibilityLabel="Card front image"
      testID="card-front-image"
    >
      {props.cardType === CardTypeEnum.DebitCard ? (
        <AmplitudeMask style={styles.amplitudeMask} blockStyleMask>
          <View style={styles.textFrontContainer}>
            <BodyXSText
              style={styles.textNameFront}
              numberOfLines={0}
              allowFontScaling={false}
              testID="first-name"
            >
              {props.firstNameText}
            </BodyXSText>
            <BodyXSText
              style={styles.textNameFront}
              numberOfLines={0}
              allowFontScaling={false}
            >
              {props.lastNameText}
            </BodyXSText>
          </View>
        </AmplitudeMask>
      ) : null}
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  amplitudeMask: {
    flex: 1,
  },
  frontImageContainer: {
    height: 343,
    justifyContent: 'space-between',
    width: 215,
  },
  textFrontContainer: {
    bottom: theme.spacing.m,
    left: theme.spacing.m,
    position: 'absolute',
  },
  textNameFront: {
    ...theme.typography.body.xs,
    color: theme.color.text.inverse,
  },
});
